import React, {useState, useEffect} from 'react';
import './DashboardFeedback.css'
import MuiTable from '../../DashboardComponents/MuiTable/MuiTable';
import PieChartCard from '../../DashboardComponents/PieChartCard/PieChartCard';
import InfoCard from '../../DashboardComponents/InfoCard/InfoCard';
import ColumnBarChartCard from '../../DashboardComponents/ColumnBarChartCard/ColumnBarChartCard';

export default function DashboardFeedback({data}) {
    const [tableData, settableData] = useState({data:[]});

    // Pie chart data
    const [pieChartData, setpieChartData] = useState({
        series: [],  
        labels: [],
    });

    // Column chart data
    const [columnBarChartData, setcolumnBarChartData] = useState({
      series: [
        {
            data: []
        }
    ],  
      categories: [],
    });

    useEffect(() => {
        console.log(data)
        if (data?.sentimentAnalysis && data?.feedbackTableData && data?.sentimentAnalysis) {
            const transformedData = Object.keys(data.feedbackTableData.feedback_id).map(key => ({
                feedback_id: data.feedbackTableData.feedback_id[key],
                email: data.feedbackTableData.email[key],
                subject: data.feedbackTableData.subject[key],
                comments: data.feedbackTableData.comments[key]
            }));
        
            settableData({
                data: transformedData
            });

            setpieChartData({
                series: Object.values(data.sentimentAnalysis.percentage),
                labels: Object.values(data.sentimentAnalysis.sentiment)
            })

            // setcolumnBarChartData({
            //     series: [
            //         {
            //             data: Object.values(data.feedbackMonthTable.month_year_created),
            //         }
            //     ],
            //     categories: Object.values(data.feedbackMonthTable.total_projects)
            // })
        }
    }, [data]);
   
    return (
        <div>
            <div className='feedbackrow1'>
                <PieChartCard pieChartData={pieChartData}/>
                {/* <ColumnBarChartCard columnBarChartData={columnBarChartData}/> */}
                <InfoCard cardText={data?.latestFeedback.feedback} cardLabel={'Latest Feedback'}/>
            </div>
            <div className='feedbackrow2'>
                <MuiTable tableData={tableData.data}/>
            </div>
        </div>
    );
}